/**
 * Strips all non-digit characters and normalizes a US phone number to E.164 format (+1XXXXXXXXXX).
 * Returns null if the input cannot be recognized as a valid US number.
 */
export function normalizePhone(phone: string): string | null {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  return null;
}

/**
 * Returns true if the phone string can be normalized to a valid US E.164 number.
 */
export function isValidPhone(phone: string): boolean {
  return normalizePhone(phone) !== null;
}

/**
 * Validates an email address using a standard RFC-5322–inspired regex.
 */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

/**
 * Converts a normalized +1XXXXXXXXXX string into (XXX) XXX-XXXX display format.
 * Returns the input as-is if it doesn't match the expected pattern.
 */
export function phoneDisplayFormat(phone: string): string {
  const match = phone.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  if (!match) return phone;
  return `(${match[1]}) ${match[2]}-${match[3]}`;
}
